const key = 'cabmun-banner';

type Props = {
	bannerIndex?: number;
};

function set(params: Props) {
	sessionStorage.setItem(key, JSON.stringify(params));
}

function get(): Props {
	return JSON.parse(sessionStorage.getItem(key) || '{}');
}

export const getCurrentBannerIndex = () => get().bannerIndex;

export const setCurrentBannerIndex = (bannerIndex: number) => {
	set({ ...get(), bannerIndex });
};
